import type { ChannelId } from '@/interfaces/service/appstore/appstore.interface';
import { convertQueryParam } from '../utils/path';

export const BASE_URL = 'https://medilawyer.co.kr';

export const ROUTES = {
  getMainDashboard: (appStoreId?: number) => {
    return `/dashboard${appStoreId ? '/' + appStoreId : ''}`;
  },
  getLogin: (redirectUrl?: string) => {
    return `/login${redirectUrl ? `?redirectUrl=${redirectUrl}` : ''}`;
  },
  getSignUp: (redirectUrl?: string) => {
    return `/auth/signup${redirectUrl ? `?redirectUrl=${redirectUrl}` : ''}`;
  },
  getRedirectMiddleware: (params?: { type: 'UNAUTHENTICATED' | 'TOKEN_EXPIRED' | undefined; message?: string }) => {
    return `/redirect${params?.type || params?.message ? convertQueryParam(params) : ''}`;
  },
  getOrganization: () => {
    return `/organization`;
  }
};

export const REVIEW_LIST_ROUTES = {
  getStoreDashboard: (appStoreId: number) => {
    return `/stores/${appStoreId}/dashboard`;
  },
  getReviews: (appStoreId: number) => {
    return `/stores/${appStoreId}/reviews`;
  },
  getSearch: (searchWord?: string) => {
    return `/search${searchWord ? '?word=' + searchWord : ''}`;
  },
  getSearchWaiting: (appStoreId: number) => {
    return `/search/waiting/${appStoreId}`;
  },
  getInsertAccountInfo: (appStoreId: number, channelId: ChannelId) => {
    return `/stores/${appStoreId}/account/info${convertQueryParam({ appStoreId, channelId })}`;
  },
  getAccountAuth: (appStoreId: number, channelId: ChannelId, type: 'sms' | 'tms') => {
    return `/stores/${appStoreId}/account/auth${convertQueryParam({ appStoreId, channelId, type })}`;
  },
  getSettingsPage: () => '/review/settings'
};
